import cx from 'classnames';
import React, { ComponentPropsWithoutRef, useMemo } from 'react';

import { ROBOT_COORD } from '../robot.constants';
import { RobotPosition, RobotProblem, RobotSkinResource, RobotSpriteOptions } from '../robot.types';

// @ts-ignore
import styles from './robot__field.module.scss';
import { cellPosition, getResourceUrl } from './utils';

interface Props extends ComponentPropsWithoutRef<'div'> {
    className?: string;
    position: RobotPosition;
    skin?: RobotSkinResource;
    resources?: RobotProblem['resources'];
    children?: React.ReactNode;
    options?: RobotSpriteOptions;
}

export const FieldSprite = React.memo(function FieldSprite({
    resources,
    skin,
    className,
    position,
    options,
    ...props
}: Props) {
    return (
        <div
            {...props}
            className={cx(styles.sprite, className)}
            data-test-position-x={position[ROBOT_COORD.HORIZONTAL]}
            data-test-position-y={position[ROBOT_COORD.VERTICAL]}
            style={{
                ...cellPosition(position),
                backgroundImage: getResourceUrl(resources, skin),
                backgroundSize: options?.background_size,
            }}
        />
    );
});

export function useSprite(resources?: Props['resources']) {
    return useMemo(
        () =>
            function Sprite(props: Props) {
                return <FieldSprite resources={resources} {...props} />;
            },
        [resources]
    );
}
